import LoginRoute from "./pages/Login/route";
import DashboardRoute from "./pages/Dashboard/route";
import InvitationRoute from "./pages/Invitation/route";
import ForgotPasswordRoute from "./pages/ForgotPassword/route";
import ResetPasswordRoute from "./pages/ResetPassword/route";

const routes = [
  LoginRoute,
  DashboardRoute,
  InvitationRoute,
  ForgotPasswordRoute,
  ResetPasswordRoute,
];

export default routes;